<template>
  <div>
    <b-modal id="modal-input-asuransi" size="lg" centered :title="$store.state.modal.tambahDataAsuransi" header-bg-variant="primary" header-text-variant="light">
      <b-form>
        <b-form-group :label="$store.state.form.asuransi" label-cols-md="3">
          <Multiselect
            :state="checkIfValid('masterAsuransiId')"
            v-model="$v.dataAsuransi.masterAsuransiId.$model"
            :disabled="false"
            :options="asuransi"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaAsuransi"
            track-by="id"
            :placeholder="$store.state.form.pilih"
          ></Multiselect>
        </b-form-group>

        <b-form-group :label="$store.state.form.potongan" label-cols-md="3">
          <b-form-input type="number" :state="checkIfValid('potonganAsuransi')" v-model="$v.dataAsuransi.potonganAsuransi.$model"></b-form-input>
        </b-form-group>

        <b-form-group :label="$store.state.form.nomor" label-cols-md="3">
          <b-form-input type="number" :state="checkIfValid('nomorAsuransi')" v-model="$v.dataAsuransi.nomorAsuransi.$model"></b-form-input>
        </b-form-group>
      </b-form>

      <template #modal-footer>
        <b-button variant="primary" :disabled="!isValid || busy" @click="simpanAsuransi()">
          {{ button }}
        </b-button>
        <b-button variant="secondary" @click="$bvModal.hide('modal-input-asuransi')">
          {{ $store.state.form.batal }}
          <!-- Cancel button text from form state -->
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "modalInput",
  props: ["data", "asuransi"],
  data() {
    return {
      dataAsuransi: {
        masterAsuransiId: "",
        nomorAsuransi: "",
        potonganAsuransi: "",
      },
      button: "Simpan",
      busy: false,
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.dataAsuransi, null, 4);
    },
    isValid() {
      return !this.$v.dataAsuransi.$invalid;
    },
    isDirty() {
      return this.$v.dataAsuransi.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    dataAsuransi: {
      masterAsuransiId: {
        required,
      },
      potonganAsuransi: {
        required,
      },
      nomorAsuransi: {
        required,
      },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.dataAsuransi[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    simpanAsuransi() {
      let vm = this;
      vm.busy = true;
      vm.button = "Mohon Tunggu";
      vm.dataAsuransi.masterAsuransiId = vm.dataAsuransi.masterAsuransiId.id;
      vm.dataAsuransi.dataKaryawanId = vm.data.dataKaryawanId;
      vm.$axios
        .post("poolPotonganAsuransi/register", vm.dataAsuransi)
        .then((res) => {
          console.log("simpan asuransi", res);
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL MENDAFTARKAN ASURANSI",
              showing: true,
            });
            vm.reset();
            vm.$bvModal.hide("modal-input-asuransi");
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch((err) => {
          vm.button = "Simpan";
          vm.busy = false;
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: err.message.toUpperCase(),
            showing: true,
          });
        });
    },
    reset() {
      let vm = this;
      vm.$v.$reset();
      vm.dataAsuransi.masterAsuransiId = "";
      vm.dataAsuransi.nomorAsuransi = "";
      vm.dataAsuransi.potonganAsuransi = "";
    },
  },
};
</script>
